export const addCssRules = (rules: string) => {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = rules;
  document.getElementsByTagName('head')[0].appendChild(style);
};
